<template>
  <!--  <slot name="">-->
  <div class="carousel-outer">

    <button class="carousel-button" @click="prev" :class="[hideArrows ? 'hidden-arrow' : '']"><i class="fa fa-chevron-left text-[#ffa700]"></i></button>
    <div class="carousel" ref="carousel">
      <div class="inner" ref="inner">
        <slot>
        </slot>
      </div>
    </div>
    <button class="carousel-button" @click="next" :class="[hideArrows ? 'hidden-arrow' : '']"><i class="fa fa-chevron-right text-[#ffa700]"></i></button>

  </div>
</template>

<script>

export default {
  props: {
    impactCount: Number
  },
  data() {
    return {
      innerStyles: {},
      hideArrows: false
    }
  },
  methods: {
    next() {
      this.move(1);
    },

    prev() {
      this.move(-1);
    },

    move(moveConstant) {
      const innerWidth = this.$refs.inner.scrollWidth;
      const totalCards = this.impactCount;
      const carousel = this.$refs.carousel;
      const setStep = carousel.scrollLeft + (moveConstant * (innerWidth / totalCards));

      carousel.scrollTo({
        left: setStep,
        behavior: 'smooth'
        })
      }
    }
}
</script>
